import ApiFetchers from "@/apis/api_fetchers"
import { PATHS } from "@/constants/path"
import { useAuthRequiredExecuteCallback } from "@/features/useSearchAction"
import { signalIndexPath } from "@/features_signal/indexPath"
import kycRequiredMethods from "@/features_signal/kyc/kycRequiredMethods"
import { CustomError } from "@/utils/error"
import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

/**
 *
 * @description 进入游戏的hook
 */
export function useEnterGame() {
    const navigate = useNavigate()
    const authRequiredExecute = useAuthRequiredExecuteCallback()

    const enterGame = useCallback(
        async (code: string, clearPath?: boolean) => {
            try {
                const resp = await ApiFetchers.refGetGameLaunch({
                    code,
                })
                if (clearPath) {
                    signalIndexPath.value = ""
                }

                const gameUrl = `${PATHS.GAME_PAGE_BASE}/${code}`

                // 默认在应用内跳转
                return navigate(gameUrl, {
                    state: {
                        from: location.pathname,
                        content: resp,
                    },
                })
            } catch (error) {
                if (error instanceof CustomError) {
                    toast.error(error.message)
                } else {
                    toast.error(String(error))
                }
            }
        },
        [navigate],
    )

    const handleEnterGame = useCallback(
        async (code: string, clearPath?: boolean) => {
            await authRequiredExecute(async () => {
                await kycRequiredMethods.execute("play", async () => {
                    return enterGame(code, clearPath)
                })
            })
        },
        [enterGame, authRequiredExecute],
    )

    return {
        handleEnterGame,
    }
}
